// Builds the v2 blueprint payload from the project's services: one
// project-services envelope per service, with the page's quantity and
// resource edits applied. The API fills in the project phases and project
// resources the envelopes point at.
export const toServiceEnvelope = (service, quantity, resourceId) => {
  const relationships = {};
  for (const key of ["service", "project-phase", "project-resource"]) {
    const data = service.relationships?.[key]?.data;
    if (data !== undefined) relationships[key] = { data };
  }
  // A different catalog resource replaces the project resource; the API
  // finds or creates the matching project resource when it applies the line.
  if (resourceId) {
    delete relationships["project-resource"];
    relationships.resource = { data: { type: "resources", id: resourceId } };
  }
  return {
    id: service.id,
    type: "project-services",
    attributes: {
      ...service.attributes,
      ...(quantity !== undefined ? { quantity } : {}),
    },
    relationships,
  };
};

// Edits are recorded in order, so the last one for a service wins.
const lastEdit = (edits, serviceId, key) => {
  const edit = edits.filter((e) => e.service === serviceId).pop();
  return edit ? edit[key] : undefined;
};

const buildBlueprintPayload = (services, changedQuantities, changedResources) =>
  services.map((service) => {
    const currentResourceId = service.relationships?.resource?.data?.id;
    const resourceId = lastEdit(changedResources, service.id, "resourceId");
    return toServiceEnvelope(
      service,
      lastEdit(changedQuantities, service.id, "quantity"),
      resourceId && resourceId !== currentResourceId ? resourceId : undefined
    );
  });

export default buildBlueprintPayload;
